<template>
  <div class="tempus-iframe-900-container pre-cart">
    <div class="container">
      <div class="row py-4">
        <div class="col">

          <h3 class="font-weight-bold" :class="$deploymentIs('cryptology') ? 'font-mon' : ''" :style="$deploymentIn(['breakescape', 'taketheexit']) ? 'letter-spacing: 0;' : ''">{{ location.booking_options.c2b_modal_title }}</h3>

          <h2 class="mb-2" v-html="location.booking_options.c2b_message"></h2>
          <h3 class="mb-2" v-if="location.booking_options.c2b_show_telephone">Our number is <a :href="'tel:' + location.telephone">{{ location.telephone }}</a></h3>
          <h3 class="mb-2" v-if="location.booking_options.c2b_show_email">Our email address is <a :href="'mailto:' + location.email">{{ location.email }}</a></h3>

        </div>
      </div>

      <div class="row py-4">
        <div class="col btn-group">

          <button type="button" class="btn btn-lg btn-danger" @click="tryAnotherRoomSlot">
            Try another booking slot <span class="material-icons" style="position: relative; top: 5px;">undo</span>
          </button>
          <button type="button" class="btn btn-lg btn-primary" @click="goToContactPage">
            Go To Contact Page <span class="material-icons" style="position: relative; top: 5px;">ring_volume</span>
          </button>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
export default {
  props: {
    consoleDebug: {
      type: Boolean,
      default: false,
    },
    location: {
      type: Object,
      required: true,
    },
    c2bRoomSlot: {
      type: Object,
    },
    showCallToBookAsSold: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {

    };
  },

  watch: {

  },

  computed: {
  },

  methods: {
    tryAnotherRoomSlot() {
      if (this.consoleDebug) console.log('BookingCheckoutIframeCallToBook::tryAnotherRoomSlot');
      this.$emit('try-another-room-slot', true);
    },
    goToContactPage() {
      window.location.href = this.location.locationContactHref;
    },
  },

  mounted() {

  },
}
</script>
